import React, { useState } from 'react';
import {
    InputAdornment,
    useTheme,
} from "@mui/material";
import { toast } from "react-toastify";
import {
    useSignupMutation
} from "../store/auth/authApiSlice";
import { Box } from "@mui/material";
import CustomButton from "../theme/style-components/CustomButton";
import CustomInput from "../theme/style-components/CustomInput";
import * as yup from "yup";
import { useFormik } from "formik";
import { showError } from "../shared/helperFunction";
import { useLocation, useNavigate } from 'react-router-dom';
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import EmailVerify from './EmailVerify';

const SignUp = () => {
    const [signup, { isLoading }] = useSignupMutation();
    const location = useLocation();
    const { search } = location;
     const [passwordShow, setPasswordShow] = useState(true);
     const [verifyEmail, setVerifyEmail] = useState(false);
    const [signupEmail, setSignupEmail] = useState('');
    const theme = useTheme();
    const navigator=useNavigate();

    const validationSchema = yup.object({
        email: yup.string().email("Please enter a valid email").required("Please enter a email"),
        password: yup.string().required("Please enter a password"),
        first_name: yup.string().required("Please enter first name"),
        last_name: yup.string().required("Please enter last name"),
        company_name: yup.string().required("Please enter company name"),
        company_description: yup.string().required("Please enter company description"),
        organization_name: yup.string().required("Please enter organization name"),
        organization_description: yup.string().required("Please enter organization description"),
    })
    const formik = useFormik({
        initialValues: {
            email: "",
            first_name: "",
            last_name: "",
            company_name: "",
            company_description: "",
            organization_name: "",
            organization_description: "",
            // generated_from: search === "?fredit" ? "fredit" : "brangchain"
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            const { email, password, first_name, last_name, company_name, company_description, organization_name, organization_description } = values;

            try {
                const response = await signup({ email, password,first_name, last_name, company_name, company_description, organization_name, organization_description }).unwrap();
                if (response?.message) {                    
                    toast.success(response?.message);
                    setSignupEmail(email);
                    setVerifyEmail(true);
                }
            } catch (err) {
                if (err) {
                    showError(err?.data);
                }
            }
        }
    });
    
    return (
        <>
            {verifyEmail ? (
                <EmailVerify email={signupEmail} />
            ) : (
                <Box>
                    <Box sx={{ marginBottom: "15px" }}>
                        <CustomInput
                            id="email"
                            variant="outlined"
                            margin="normal"
                            placeholder="Email"
                            name="email"
                            label="Email"
                            required
                            fullWidth
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            error={
                                formik.touched.email &&
                                Boolean(formik.errors.email)
                            }
                            helperText={
                                formik.touched.email && formik.errors.email
                            }
                        />
                    </Box>
                    <Box sx={{ marginBottom: "15px" }}>
                          <CustomInput
                            id="password"
                            variant="outlined"
                            margin="normal"
                            placeholder="Password"
                            label="Password"
                            name="password"
                            type={!passwordShow ? "text" : "password"}
                            required
                            fullWidth
                            value={formik.values.password}
                            onChange={formik.handleChange}
                            error={formik.touched.password && Boolean(formik.errors.password)}
                            helperText={formik.touched.password && formik.errors.password}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment
                                  position="end"
                                  sx={{
                                    cursor: "pointer",
                                    "& svg": {
                                      fill: theme.palette.grey["A400"],
                                    },
                                  }}
                                >
                                  {passwordShow ? (
                                    <VisibilityOffIcon
                                      onClick={() => setPasswordShow(!passwordShow)}
                                    />
                                  ) : (
                                    <VisibilityIcon
                                      onClick={() => setPasswordShow(!passwordShow)}
                                    />
                                  )}
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Box>
                    <Box sx={{ marginBottom: "15px", display: "flex", justifyContent: "space-between", gap: "10px" }}>
                        <CustomInput
                            id="first_name"
                            variant="outlined"
                            margin="normal"
                            placeholder="First Name"
                            name="first_name"
                            label="First Name"
                            required
                            fullWidth
                            value={formik.values.first_name}
                            onChange={formik.handleChange}
                            error={
                                formik.touched.first_name &&
                                Boolean(formik.errors.first_name)
                            }
                            helperText={
                                formik.touched.first_name && formik.errors.first_name
                            }
                        />
                        <CustomInput
                            id="last_name"
                            variant="outlined"
                            margin="normal"
                            placeholder="Last Name"
                            name="last_name"
                            label="Last Name"
                            required
                            fullWidth
                            value={formik.values.last_name}
                            onChange={formik.handleChange}
                            error={
                                formik.touched.last_name &&
                                Boolean(formik.errors.last_name)
                            }
                            helperText={
                                formik.touched.last_name && formik.errors.last_name
                            }
                        />
                    </Box>
                    <Box sx={{ marginBottom: "15px" }}>
                        <CustomInput
                            id="company_name"
                            variant="outlined"
                            margin="normal"
                            placeholder="Company Name"
                            name="company_name"
                            label="Company Name"
                            required
                            fullWidth
                            value={formik.values.company_name}
                            onChange={formik.handleChange}
                            error={
                                formik.touched.company_name &&
                                Boolean(formik.errors.company_name)
                            }
                            helperText={
                                formik.touched.company_name && formik.errors.company_name
                            }
                        />
                    </Box>
                    <Box sx={{ marginBottom: "15px" }}>
                        <CustomInput
                            id="company_description"
                            variant="outlined"
                            margin="normal"
                            placeholder="Company Description"
                            name="company_description"
                            label="Company Description"
                            required
                            fullWidth
                            value={formik.values.company_description}
                            onChange={formik.handleChange}
                            error={
                                formik.touched.company_description &&
                                Boolean(formik.errors.company_description)
                            }
                            helperText={
                                formik.touched.company_description && formik.errors.company_description
                            }
                        />
                    </Box>
                    <Box sx={{ marginBottom: "15px" }}>
                        <CustomInput
                            id="organization_name"
                            variant="outlined"
                            margin="normal"
                            placeholder="Organization Name"
                            name="organization_name"
                            label="Organization Name"
                            required
                            fullWidth
                            value={formik.values.organization_name}
                            onChange={formik.handleChange}
                            error={
                                formik.touched.organization_name &&
                                Boolean(formik.errors.organization_name)
                            }
                            helperText={
                                formik.touched.organization_name && formik.errors.organization_name
                            }
                        />
                    </Box>
                    <Box sx={{ marginBottom: "15px" }}>
                        <CustomInput
                            id="organization_description"
                            variant="outlined"
                            margin="normal"
                            placeholder="Organization Description"
                            name="organization_description"
                            label="Organization Description"
                            required
                            fullWidth
                            value={formik.values.organization_description}
                            onChange={formik.handleChange}
                            error={
                                formik.touched.organization_description &&
                                Boolean(formik.errors.organization_description)
                            }
                            helperText={
                                formik.touched.organization_description && formik.errors.organization_description
                            }
                        />
                    </Box>
                    <Box sx={{ marginTop: "10px", marginBottom: "15px" }}>
                        <CustomButton
                            fullWidth
                            disabled={isLoading || !formik.isValid}
                            size="large"
                            color="primary"
                            onClick={formik.handleSubmit}
                            buttonName={isLoading ? "Signing up..." : "Sign Up"}
                        />
                    </Box>
                </Box>
            )}
        </>
    )
}

export default SignUp